import React from 'react'
import { TawreedDropdownProps, TawreedMenuDropdown } from '../../../../../../common'

export const InvoiceDiscountTypesDropDown: React.FC<TawreedDropdownProps> = (props) => {

    return (<TawreedMenuDropdown {...props} menu="invoiceDiscountTypes" />)
}
